// Registry نوع سیگنال - نوع جدید = یه entry جدید (بخش ۴.۳ سند معماری)
// پسوندِ `.ts` روی وارداتِ داخلی، مثلِ بقیه‌ی core: تست‌های یونیت با
// node --test مستقیم روی TypeScript اجرا می‌شن و بدونِ پسوند ماژول رو پیدا
// نمی‌کنن. تنها فایلِ این پوشه بود که این قاعده رو نداشت، و تا وقتی هیچ
// تستی به این زنجیره نمی‌رسید، هیچ‌کس هم نمی‌فهمید.
import { t } from '../lib/i18n.ts';
import type { Signal, SignalKind } from './types.ts';

export interface SignalKindMeta {
  kind: SignalKind;
  emoji: string;
  titleKey: string;
  subKey: string;
  badge(s: Signal): string;
}

const registry = new Map<SignalKind, SignalKindMeta>();
export const registerKind = (m: SignalKindMeta) => registry.set(m.kind, m);
export const kindMeta = (k: SignalKind): SignalKindMeta =>
  registry.get(k) ?? registry.get('definite')!;
export const allKinds = (): SignalKindMeta[] =>
  ['definite', 'if_company', 'hosting', 'open_idea'].map((k) => registry.get(k as SignalKind)!);

/**
 * نوع‌هایی که برای سیگنالِ زاده‌ی یک رخدادِ کاتالوگ معنی ندارند.
 *
 * «خودم میزبانم» یعنی مهمانی و شامِ خانه‌ی خودت. وقتی سیگنال از روی یک
 * رخدادِ کاتالوگ ساخته می‌شود (`signals.event_id`)، میزبانش یکی دیگر است —
 * کاربر فقط دارد بقیه را می‌برد آن‌جا. پس این گزینه در فرم نشان داده
 * نمی‌شود، نه اینکه انتخابش خطا بدهد: چیزی که هیچ‌وقت درست نیست، اصلاً
 * نباید در فهرست باشد.
 */
const NOT_FROM_EVENT: SignalKind[] = ['hosting'];

/**
 * گزینه‌های نوع برای فرمِ ساخت/ویرایش.
 *
 * `current` برای ویرایش است: سیگنالِ قدیمی‌ای که هم رخداد دارد هم «خودم
 * میزبانم» (از قبل از این قاعده) نباید با باز شدنِ فرم گزینه‌ی فعلی‌اش را
 * گم کند — وگرنه فهرست یک مقدارِ انتخاب‌شده‌ی نامرئی دارد.
 */
export const kindsFor = (opts: { fromEvent: boolean; current?: SignalKind }): SignalKindMeta[] =>
  allKinds().filter((m) =>
    !opts.fromEvent || m.kind === opts.current || !NOT_FROM_EVENT.includes(m.kind));

registerKind({ kind: 'definite', emoji: '✅', titleKey: 'kindDefinite', subKey: 'kindDefiniteSub',
  badge: () => t('kindDefinite') });
registerKind({ kind: 'if_company', emoji: '🤔', titleKey: 'kindIfCompany', subKey: 'kindIfCompanySub',
  badge: () => t('kindIfCompany') });
registerKind({ kind: 'hosting', emoji: '🏠', titleKey: 'kindHosting', subKey: 'kindHostingSub',
  badge: () => t('kindHosting') });
registerKind({ kind: 'open_idea', emoji: '💭', titleKey: 'kindOpenIdea', subKey: 'kindOpenIdeaSub',
  badge: () => t('kindOpenIdea') });
